module.exports = __webpack_public_path__ + "static/media/view6.8fdf4ebf.jpg";